import { DOM, breakpoints, classes, matchMedia, matchMediaMax } from '../const';

const { $window } = DOM;

const anchorBoxes = () => {
  const $anchorBox = $('.anchor-box-wrapper');
  let $staticAnchorBox;
  let anchorUp = false;

  const hideAnchorBox = ($anchorBoxElem) => {
    $anchorBoxElem.css({'max-width':'0px','margin':'0px;','opacity':'0'});
  };

  const showAnchorBox = ($anchorBoxElem) => {
    $anchorBoxElem.css({'max-width':'','margin':'','opacity':'1'});
  };

  const toggleAnchorForce = (up) => {
    anchorUp = up;

    if (up) {
      hideAnchorBox($anchorBox);
      $staticAnchorBox.toggle(true);
      $staticAnchorBox.toggleClass('active', false);
      $staticAnchorBox.find('.anchor-links-wrap').slideUp();
      $anchorBox.find('.anchor-links-wrap').slideUp();
      $anchorBox.toggleClass('active', false);
    } else {
      showAnchorBox($anchorBox);
      $staticAnchorBox.toggle(false);
      $anchorBox.toggleClass('active', true);
      $anchorBox.find('.anchor-links-wrap').slideDown();
      if ($(window).width() > 991) {
        $staticAnchorBox.toggleClass('active', false);
        $staticAnchorBox.find('.anchor-links-wrap').slideUp();
      }
      else {
        $staticAnchorBox.toggleClass('active', true);
        $staticAnchorBox.find('.anchor-links-wrap').slideDown();
      }
    }
  }

  const isPageOneAndMobileFunc = () => {
    const isPageOne = $('body').attr('id') === 'page-1';
    const isMobile = $(window).width() <= 991;
    return isPageOne && isMobile;
  };

  const checkAnchorPosition = () => {
    const scrollTop = $window.scrollTop();
    const boxTop = $('.anchor-box-wrapper')[1].offsetTop;
    if (boxTop < scrollTop && !anchorUp) {
      toggleAnchorForce(true)
    } else if (boxTop > scrollTop && anchorUp) {
      toggleAnchorForce(false)
    }
  }

  const toggleAnchor = (parent) => {
    parent.toggleClass('active');
    if (parent.hasClass('active')) {
      parent.find('.anchor-links-wrap').slideDown();
    } else {
      parent.find('.anchor-links-wrap').slideUp();
    }
  }

  const isPageOneAndMobile = isPageOneAndMobileFunc();
  if ($anchorBox.length > 0 && !isPageOneAndMobile) {
    $staticAnchorBox = $('.js-site-main').prepend($anchorBox[0].outerHTML).find(' > .anchor-box-wrapper');
    $staticAnchorBox.toggleClass('active', false);
    $staticAnchorBox.find('.anchor-links-wrap').slideUp();
    $staticAnchorBox.toggleClass('fixed', true);
    $staticAnchorBox.css('opacity', '1');
    $staticAnchorBox.toggle(false);
    $window.scroll(checkAnchorPosition);

    $('.anchor-box-wrapper').on('click', '.anchor-box-close-button', function () {
      const parent = $(this).closest('.anchor-box-wrapper');
      toggleAnchor(parent);
    })

    $window.resize(() => {
      checkAnchorPosition();
    })
  }
};

export default anchorBoxes;
